import { render, staticRenderFns } from "./CoEventCreate.vue?vue&type=template&id=62f98505&"
import script from "./CoEventCreate.vue?vue&type=script&lang=ts&"
export * from "./CoEventCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports